export const DEFAULT_SELECTED_QUARTERS = [1]
